const servicesList = [
   {
      text: 'Front-end development',
      textColor: 'text-base',
      background: 'bg-indigo-900',
      icon: 'M5 13l4 4L19 7'
   },
   {
      text: 'Custom domain acquisition',
      textColor: 'text-base',
      background: 'bg-indigo-900',
      icon: 'M5 13l4 4L19 7'
   },
   {
      text: 'Cloud hosting management',
      textColor: 'text-base',
      background: 'bg-indigo-900',
      icon: 'M5 13l4 4L19 7'
   },
   {
      text: 'Web design',
      textColor: 'text-gray-300',
      background: 'bg-gray-300',
      icon: 'M6 18L18 6M6 6l12 12'
   },
   {
      text: 'Content creation',
      textColor: 'text-gray-300',
      background: 'bg-gray-300',
      icon: 'M6 18L18 6M6 6l12 12'
   }]

   export default servicesList